export const UPDATE_BOOKER_DETAILS = 'UPDATE_BOOKER_DETAILS'

export const updateBookerDetails = data => {
  return {
    type: UPDATE_BOOKER_DETAILS,
    data,
  }
}
